import { ViewResolver } from '@Components/ViewResolver';
import DashboardDesktop from './desktop/DashboardDesktop';
import DashboardMobile from './mobile/DashboardMobile';

interface DashboardPageProps {
  children: JSX.Element;
}

const DashboardPage: React.FC<DashboardPageProps> = ({ children }) => {
  return (
    <ViewResolver
      desktop={<DashboardDesktop>{children}</DashboardDesktop>}
      mobile={<DashboardMobile>{children}</DashboardMobile>}
    />
  );
};

export default DashboardPage;
